'use strict';

module Patersons {

    export class ReportDisclaimerComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/portfolioSummary/components/reportDisclaimer.component.html';
        controller = ['userCompanyService', function(userCompanyService) {
            userCompanyService.getUserCompany().then((company) => {
                this.userCompany = company;
             })
        }]
    }
}
